import React from 'react';
import PropTypes from 'prop-types';

import { compensationsShape } from 'constants/propTypes';

import SalesforceCompensationBreakdown from './SalesforceCompensationBreakdown';
import NonSalesforceCompensationBreakdown from './NonSalesforceCompensationBreakdown';

const CompensationBreakdown = ({
  isVoucher,
  isLoyalty,
  isCashTicketRefund,
  currency,
  compensateLegs,
  refundPercentage,
  compensationItems = []
}) => {
  if (compensationItems.length > 0) {
    return (
      <SalesforceCompensationBreakdown
        isVoucher={isVoucher}
        isLoyalty={isLoyalty}
        isCashTicketRefund={isCashTicketRefund}
        currency={currency}
        refundPercentage={refundPercentage}
        compensationItems={compensationItems}
        compensateLegs={compensateLegs}
      />
    );
  }

  return (
    <NonSalesforceCompensationBreakdown
      isVoucher={isVoucher}
      isLoyalty={isLoyalty}
      currency={currency}
      compensateLegs={compensateLegs}
      refundPercentage={refundPercentage}
    />
  );
};

CompensationBreakdown.propTypes = {
  isVoucher: PropTypes.bool,
  isLoyalty: PropTypes.bool,
  isCashTicketRefund: PropTypes.bool,
  currency: PropTypes.string,
  refundPercentage: PropTypes.string,
  compensateLegs: PropTypes.arrayOf(
    PropTypes.shape({
      legName: PropTypes.string,
      direction: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          itemRef: PropTypes.string,
          passengerType: PropTypes.string,
          bucketCode: PropTypes.string,
          productFamily: PropTypes.shape({
            code: PropTypes.string
          }),
          currency: PropTypes.string,
          loyaltyPoints: PropTypes.number,
          price: PropTypes.number
        })
      )
    })
  ),
  compensationItems: compensationsShape
};

export default CompensationBreakdown;
